import React from 'react'
import styles from '../Css/View360/Loader.module.css'


function Loader() {
  return (
    <div className={styles['loader-component']}>
        <div style={{width:130}}>
            <img src='ez360OrangeGradient.gif' title="loading" width="130" alt="loading" style={{opacity: 1,background:'rgba(0, 0, 0, 0)', borderRadius:'50%'}}></img>
        </div>
    </div>

    
  )
}

export default Loader